import React from "react";
import { useTranslation } from "react-i18next";
import { Lock, Globe, Activity } from "lucide-react";

export default function AuthFaq() {
    const { t } = useTranslation();

    const features = [
        { icon: Lock, label: t("auth.faq.hosting.features.ssl") },
        { icon: Globe, label: t("auth.faq.hosting.features.cdn") },
        { icon: Activity, label: t("auth.faq.hosting.features.uptime") },
    ];

    return (
        <section
            className="mt-20 md:mt-40 md:relative md:left-1/2 md:-translate-x-1/2 md:w-screen md:px-4"
            aria-label={t("auth.faq.title")}
        >
            <div className="max-w-[760px] mx-auto">
                <h2 className="font-display text-center text-[clamp(26px,5.5vw,52px)] leading-[1.1] tracking-[-0.025em] font-medium text-[#171a1f] mb-8 px-2">
                    {t("auth.faq.title")}
                </h2>

                <div className="grid gap-4">
                    <article className="bg-white border border-[#e9e7ee] rounded-[20px] shadow-[0_1px_2px_rgb(23_26_31/0.04)] p-6 sm:p-7 text-left">
                        <h3 className="text-[16px] font-medium text-[#171a1f] mb-2">
                            {t("auth.faq.q1.question")}
                        </h3>
                        <p className="text-[14.5px] leading-relaxed text-[#6b7280]">
                            {t("auth.faq.q1.answer")}
                        </p>
                    </article>

                    <article className="bg-white border border-[#e9e7ee] rounded-[20px] shadow-[0_1px_2px_rgb(23_26_31/0.04)] p-6 sm:p-7 text-left">
                        <span className="inline-flex items-center gap-1 rounded-full bg-[#f3eff9] border border-[#e8def4] py-1 px-2.5 text-[11px] font-medium text-[#7c6bb0] uppercase tracking-wide mb-3">
                            <span className="w-[5px] h-[5px] rounded-full bg-[#7c6bb0]" />
                            {t("auth.faq.hosting.badge")}
                        </span>
                        <h3 className="text-[16px] font-medium text-[#171a1f] mb-2">
                            {t("auth.faq.hosting.title")}
                        </h3>
                        <p className="text-[14.5px] leading-relaxed text-[#6b7280] mb-4">
                            {t("auth.faq.hosting.body")}
                        </p>
                        <ul className="flex flex-wrap gap-2" role="list">
                            {features.map(({ icon: Icon, label }) => (
                                <li
                                    key={label}
                                    className="inline-flex items-center gap-1.5 rounded-full bg-[#fafafa] border border-[#f1eff5] py-1.5 pl-3 pr-3.5 text-[12.5px] text-[#6b7280]"
                                >
                                    <Icon
                                        className="w-3 h-3 text-[#7c6bb0] flex-shrink-0"
                                        strokeWidth={1.8}
                                    />
                                    {label}
                                </li>
                            ))}
                        </ul>
                    </article>
                </div>
            </div>
        </section>
    );
}
